import { use, useState } from "react";

function useFilterConversations(workspaceId) {
  const [filterParams, setFilterParams] = useState({
    startDate: "",
    endDate: "",
    assistantId: "",
    extractedData: {},
    callDuration: 0,
    assignedTags: [],
    untagged: false,
  });

  const updateDate = (date) => {
    const { startDate, endDate } = date;
    setFilterParams((prevParams) => {
      return {
        ...prevParams,
        startDate,
        endDate,
      };
    });
  };

  const updateAssistantId = (assistantId) => {
    setFilterParams((prevParams) => {
      return {
        ...prevParams,
        assistantId,
      };
    });
  };

  const updateExtractedData = (extractedData) => {
    setFilterParams((prevParams) => {
      return {
        ...prevParams,
        extractedData,
      };
    });
  };

  const updateCallDuration = (callDuration) => {
    setFilterParams((prevParams) => {
      return {
        ...prevParams,
        callDuration,
      };
    });
  };

  const updateAssignedTags = (assignedTags) => {
    setFilterParams((prevParams) => {
      return {
        ...prevParams,
        assignedTags,
      };
    });
  };

  const updateUntagged = (untagged) => {
    setFilterParams((prevParams) => {
      return {
        ...prevParams,
        untagged,
      };
    });
  };

  const resetFilters = () => {
    setFilterParams({
      startDate: "",
      endDate: "",
      assistantId: "",
      extractedData: {},
      callDuration: 0,
      assignedTags: [],
      untagged: false,
    });
  };

  return {
    ...filterParams,
    updateAssistantId,
    updateDate,
    updateExtractedData,
    updateCallDuration,
    updateAssignedTags,
    updateUntagged,
    resetFilters,
  };
}

export default useFilterConversations;
